import React, { Fragment } from "react";
import { useClient } from "../../shared/hooks/client-hook";
import ModelInstance from "./ModelInstance";

const ModelInstanciator = () => {
  const { client, editor, setCamPos } = useClient();

  return (
    <group>
      {editor && editor.models && client && client.models &&
        Object.keys(client.models).map((categoryId) => {
          const category = client.models[categoryId];

          return (
            <Fragment key={categoryId}>
              {Object.values(category).map((instance) => {
                return (
                  <ModelInstance
                    url={editor.models[categoryId][instance.model].url}
                    key={instance.id}
                    instance={instance}
                    setCamPos={setCamPos}
                  />
                );
              })}
            </Fragment>
          );
        })}
    </group>
  );
};

export default ModelInstanciator;
